import type { GameManual } from '../../types';
import { nieswiadomyUmyslChapters, nieswiadomyUmyslFirstGame } from './content';
import { consolidateAddonChapters } from '../perfect-quality/consolidateAddonChapters';

export const nieswiadomyUmyslManual: GameManual = {
  chapters: consolidateAddonChapters(
    nieswiadomyUmyslChapters,
    'nightmares',
    'Koszmary'
  ),
  firstGameSteps: nieswiadomyUmyslFirstGame,
  addons: [
  {
    "id": "nightmares",
    "name": "Koszmary"
  }
],
};

export * from './content';
export * from './blockers';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
